import { render, staticRenderFns } from "./zhanghu.vue?vue&type=template&id=03ae4d92&scoped=true"
import script from "./zhanghu.vue?vue&type=script&lang=js"
export * from "./zhanghu.vue?vue&type=script&lang=js"
import style0 from "./zhanghu.vue?vue&type=style&index=0&id=03ae4d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ae4d92",
  null
  
)

export default component.exports